module.exports = {"id":"183736","name":"Dirk Marcellis","rating":"72","photo":"./data/images/photos/4/183736.png","club":{"name":"PEC Zwolle","logo":"./data/images/clubs/PECZwolle.png"},"positions":["DC"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/DirkMarcellis0.json
// module id = 1113
// module chunks = 0